/**
 * Custom hook for fetching and caching merchant data
 */

import { useQuery } from '@tanstack/react-query'
import { fetchMerchant } from '@/services/api'
import type { MerchantData } from '@/types'

/**
 * Hook to fetch merchant data by merchant code
 * @param merchantCode - The merchant code to fetch
 * @param enabled - Whether the query should run
 * @returns Query result with merchant data
 */
export function useMerchantData(merchantCode: string | null, enabled: boolean = true) {
  return useQuery<MerchantData, Error>({
    queryKey: ['merchant', merchantCode],
    queryFn: () => {
      if (!merchantCode) {
        throw new Error('Merchant code is required')
      }
      return fetchMerchant(merchantCode)
    },
    enabled: enabled && !!merchantCode,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  })
}


